"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { Spotlight } from "@/app/components/ui/spotlight";
import { GradientLine } from "@/app/components/ui/gradient-line";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export function SpotlightHero() {
  const scrollToContent = () => {
    const contentSection = document.getElementById("what-we-do-content");
    if (contentSection) {
      contentSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="h-[60vh] w-full rounded-md flex flex-col md:items-center justify-between bg-slate-950/95 relative overflow-hidden">
      {/* Top Left Gradient Line */}
      <div className="absolute left-0 top-0 w-2/3 z-20">
        <GradientLine />
      </div>

      <div className="absolute inset-0">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(to right, rgb(255 255 255 / 0.03) 1px, transparent 1px),
                             linear-gradient(to bottom, rgb(255 255 255 / 0.03) 1px, transparent 1px)`,
            backgroundSize: "60px 60px",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/80 via-slate-950/50 to-slate-950/80" />
        </div>
      </div>
      <Spotlight
        className="-top-40 left-0 md:left-60 md:-top-20"
        fill="rgb(var(--color-neon-blue))"
      />
      <div className="p-4 max-w-7xl mx-auto my-auto relative z-10 w-full flex flex-col items-center">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="px-4 py-2 rounded-full text-sm font-medium bg-[rgb(var(--color-neon-blue)_/_0.1)] text-[rgb(var(--color-neon-blue-light))] border border-[rgb(var(--color-neon-blue)_/_0.2)] mb-6"
        >
          What We Do
        </motion.span>

        <h1 className="text-4xl md:text-7xl font-bold text-center text-white">
          Complete Technology Solutions
        </h1>
        <p className="mt-4 text-lg md:text-xl text-white/80 max-w-2xl text-center mx-auto leading-relaxed font-[450]">
          See how we help businesses take control of their technology landscape.
          From day-to-day support to strategic planning, we provide the
          expertise and solutions you need to thrive in the digital age.
        </p>

        <motion.button
          className="mt-12 cursor-pointer group"
          animate={{ y: [0, 8, 0] }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          onClick={scrollToContent}
          aria-label="Scroll down to content"
        >
          <div className="flex items-center justify-center w-10 h-10 rounded-full border border-[rgb(var(--color-neon-blue)_/_0.3)] bg-[rgb(var(--color-neon-blue)_/_0.1)] backdrop-blur-sm transition-all duration-300 group-hover:border-[rgb(var(--color-neon-blue)_/_0.5)] group-hover:bg-[rgb(var(--color-neon-blue)_/_0.2)]">
            <ChevronDown className="w-5 h-5 text-[rgb(var(--color-neon-blue))] transition-transform duration-300 group-hover:scale-110" />
          </div>
        </motion.button>
      </div>

      {/* Bottom Gradient Line */}
      <div className="relative w-full z-20">
        <GradientLine />
      </div>
    </div>
  );
}
